import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, IconButton, Tooltip} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
// import Settings from '@material-ui/icons/Settings';
import DatasheetView from './DatasheetView';
import moment from 'moment';
import XLSX from 'xlsx';
import ExcelLogo from '../assets/ExcelLogo';
import FilterBox from './FilterBox';
import { VisibilityRounded } from '@material-ui/icons';
import DatePicker from './DatePicker';
import AlertDialog from './AlertDialogue';

export default class OHSInjuriesReport extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: false,
            error_message: '',
            querying: true,
            injury_reports_array: [],
            filtered_reports_array: [],
            filter_applied: false,
            filter_obj: {},
            show_dialogue: false,
            from_date: moment().subtract(1,'year').add(1,'day').format("YYYY-MM-DD"),
            to_date: moment().format("YYYY-MM-DD"),
            server_refresh_req: false,
            user_type: this.props.admin ? 'admin' : (this.props.rom? 'rom' : (this.props.job_title === 'BRANCH MANAGER'? 'branch manager': 'regular employee')) 
        }

        this.datasheetFieldSpecs = [
            { field: 'store_code', headerName: 'Branch', width: 110,  align:'center',headerAlign:'center'},
            { field: 'incident_date', headerName: 'Incident Date', width: 130},
            { field: 'injured_employee_name', headerName: 'Injured Employee', width: 170},
            { field: 'injured_employee_number', headerName: 'Empl. # (at the time)', width: 80, sortable: false},
            { field: 'injured_employees_rom_at_time', headerName: 'Manager Code (at the time)', width: 80, sortable: false},
            { field: 'injured_employee_id', headerName: 'ID Number', width: 120, sortable: false},
            { field: 'category_of_injury', headerName: 'Category', width: 120},
            { field: 'nature_of_injury', headerName: 'Nature of Inujury', width: 160, sortable: false},
            { field: 'days_of_duty', headerName: 'Days of Duty', width: 75, align:'center', sortable: false},
            { field: 'view_details', headerName: 'Description', width: 80, align:'center', sortable:false,
            renderCell: (parms) => (
                <IconButton
                    onClick={()=>this.viewDesc(parms.row)} 
                >
                    <Tooltip title="View Incident Description">
                        <VisibilityRounded/>
                    </Tooltip>
                </IconButton>
            )},
            { field: 'case_ref', headerName: 'Case #', width: 110},
            { field: 'reporting_employee_name', headerName: 'Reported by', width: 160},
            { field: 'reporting_employee_id', headerName: 'ID Number', width: 120, sortable: false},
            { field: 'created', headerName: 'Report Filed', width: 130},
        ]
    }

    componentDidMount = () => {

        Gserv.sendCommand('query_injury_reports_all',this.props.gwt,{
            from_date : this.state.from_date,
            to_date : this.state.to_date
        })
        .then(reply=>{
            // console.log('query_injury_reports reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_injury_reports) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_injury_reports) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                if (this.state.filter_applied){
                    this.setState({querying:false, injury_reports_array:reply.injury_reports? reply.injury_reports : []});
                    if (!reply.Records) {this.setState({filtered_reports_array:[]})}
                    this.applyFilter(this.state.filter_obj);
                } else {
                    this.setState({querying:false, injury_reports_array:reply.injury_reports?reply.injury_reports : [], filtered_reports_array:reply.injury_reports?reply.injury_reports : []});
                }
                
            }
        });

    };

    refreshReports = () => {
        this.setState({querying:true, server_refresh_req:false, injury_reports_array:[], filtered_reports_array: []});
        Gserv.sendCommand('query_injury_reports_all',this.props.gwt,{
            from_date : this.state.from_date,
            to_date : this.state.to_date
        })
        .then(reply=>{
            // console.log('query_injury_reports reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_injury_reports) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_injury_reports) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                if (this.state.filter_applied){
                    this.setState({querying:false, injury_reports_array:reply.injury_reports? reply.injury_reports : []});
                    if (!reply.Records) {this.setState({filtered_reports_array:[]})}
                    this.applyFilter(this.state.filter_obj);
                } else {
                    this.setState({querying:false, injury_reports_array:reply.injury_reports?reply.injury_reports : [], filtered_reports_array:reply.injury_reports?reply.injury_reports : []});
                }
            }
        });

    }

    viewDesc = (parms) => {
        // console.log('parms :>> ', parms);
        this.setState({show_dialogue:true, dialogue_object: parms})
    }
    
    dialogCallBack = () => {
        this.setState({show_dialogue:false, dialogue_object: {}});
    }
    
    resetMe = () => {
        this.setState({error: false,error_message: '',querying: true, injury_reports_array: []});
        this.componentDidMount();
    }

    exportMe = () => {
        // console.log('called exportMe...');
        if (this.state.filtered_reports_array.length>0){
            // const dateStr = new moment().format("YYYY-MM-DD");
            let fileName = 'TMS Export - Injuries on Duty for the period ' + this.state.from_date + ' to ' + this.state.to_date;
            if (this.state.filter_applied){
                fileName += ' (filtered by ' + this.state.filter_obj.type + ' = ' + this.state.filter_obj.search_string + ')';
            }
            fileName += '.xlsx';
            var ws = XLSX.utils.json_to_sheet(this.state.filtered_reports_array);
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Injuries on Duty');
            //Write to browser
            XLSX.writeFile(wb,fileName);
        }
    }

    handleFilterChange = (filterObj) => {
        if (filterObj.type==='clear'){
            this.setState({filtered_reports_array : this.state.injury_reports_array, filter_obj: {}, filter_applied:false})
        } else {
            this.setState({filter_obj:filterObj});
            this.applyFilter(filterObj);
        }
    }

    applyFilter = (filterObj) => {
        if (this.state.injury_reports_array.length > 0){
            let temp_array = [];
            switch (filterObj.type) {
                case 'name':
                    for (const record of this.state.injury_reports_array){
                        if (record.injured_employee_name.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;

                case 'number':
                    for (const record of this.state.injury_reports_array){
                        if (record.injured_employee_number.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;
 
                case 'rom':
                    for (const record of this.state.injury_reports_array){
                        if (record.injured_employees_rom_at_time.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;
            
                case 'branch':
                    for (const record of this.state.injury_reports_array){
                        if (record.store_code.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                break;
            
                default:
                    break;
            }
            this.setState({filtered_reports_array: temp_array, filter_applied:true});
        }
    }   

    handleDateRangeUpdate = (fieldObj) => {
        // console.log('fieldObj :>> ', fieldObj);
        if (fieldObj.value===''){fieldObj.value=null}
        const refresh_req = this.state[fieldObj.field] !== fieldObj.value;
        this.setState({[fieldObj.field]:fieldObj.value,server_refresh_req:refresh_req})
    }

    render() {return(
        <Grid
            container
            direction='column'
            // justifyContent='flex-start'
            // alignContent='flex-start'
            // style={{backgroundColor:'yellow'}}
        >
            {this.state.show_dialogue&&  
            <AlertDialog
                title={'Description of Injury'}
                description={'Injury to <b>' + this.state.dialogue_object.injured_employee_name + '</b> (ID' + this.state.dialogue_object.injured_employee_id + ') on ' + this.state.dialogue_object.incident_date + '<br/><br/>' + this.state.dialogue_object.incident_description}
                buttons={['CLOSE']}
                callBack={this.dialogCallBack}
            />}
            
            <Grid item>
            <Paper
                elevation={3}
                style={{
                    // backgroundColor:'yellow',
                    width:1280
                }}
            >

                <Grid
                    container
                    // style={{backgroundColor:'yellow'}}
                    justifyContent='center'
                    alignContent='center'
                >

                    <Grid item xs={5}>
                        <Grid
                            container
                            justifyContent='center'
                            alignItems='center'
                        >

                            <Grid item xs={2} style={{padding:10}}>
                                <Typography>Incident Date:</Typography>
                            </Grid>

                            <Grid item xs={4} style={{padding:10}}>
                                <DatePicker 
                                    fieldMap={{
                                        field: "from_date",
                                        headerName: "From?",
                                        f_inputType:'datepicker',
                                        f_required:false,
                                        f_show:true,
                                        f_disable_future:true,
                                        f_disable_past:false}}
                                    setField={this.handleDateRangeUpdate}
                                    editRecord={{from_date:this.state.from_date}}
                                    // disabled={this.state.creating_nomination}
                                />
                            </Grid>
                            
                            <Grid item xs={4} style={{padding:10}}>
                                <DatePicker 
                                    fieldMap={{
                                        field: "to_date",
                                        headerName: "To?",
                                        f_inputType:'datepicker',
                                        f_required:false,
                                        f_show:true,
                                        f_disable_future:true,
                                        f_disable_past:false}}
                                    setField={this.handleDateRangeUpdate}
                                    editRecord={{to_date:this.state.to_date}}
                                    // disabled={this.state.creating_nomination}
                                />
                            </Grid>

                            <Grid item xs={2}>
                                <Button 
                                    color='primary'
                                    variant='outlined'
                                    onClick={this.refreshReports}
                                    disabled={this.state.querying||!this.state.server_refresh_req||!this.state.from_date||!this.state.to_date}
                                    style={{marginTop:10}}
                                >
                                    Refresh
                                </Button>
                            </Grid>

                        </Grid>
                    </Grid>

                    <Grid item xs={1}>
                        <div style={{display:'inline-flex', height:'100%', justifyContent:'center', alignItems:"center"}}>
                            <Tooltip title="Export to Excel">
                            <span>
                            <IconButton 
                                aria-label='Export to Excel'
                                onClick={this.exportMe}
                                disabled={this.state.filtered_reports_array.length===0}
                            >
                                <ExcelLogo />
                            </IconButton>
                            </span>
                            </Tooltip>
                        </div>
                    </Grid>

                    <Grid item xs={2}>
                        <Typography
                            style={{padding:10}}
                            color='primary'
                        >
                            <b>Reported Injuries on Duty</b><br/>
                            {this.state.user_type === 'branch manager'? 'For Branch Code: ' : (this.state.user_type === 'rom'? 'For Branches linked to Manager Code: ' : (this.state.user_type === 'admin'? '' : '*Invalid user type'))}
                            <b>{this.state.user_type === 'branch manager'? this.props.store_code : (this.state.user_type === 'rom'? this.props.rom_code : '')}</b>
                        </Typography>
                    </Grid>

                    <Grid item xs={4}>
                        <Grid 
                            container
                            alignItems='center'
                            justifyContent='space-evenly'
                            style={{height:'100%'}}
                        >
                            <FilterBox
                                setParentFilter={this.handleFilterChange}
                                data_populated={this.state.injury_reports_array.length>0? true : false}
                                filter_applied={this.state.filter_applied}
                                filter_obj={this.state.filter_obj}
                                show_hod_filter={true}
                                show_branch_filter={true}
                                // show_cycle_filter={true}
                            />
                        </Grid>
                    </Grid>

                </Grid>


                {/* Datagrid goes here */}
                <DatasheetView 
                    dataset={this.state.filtered_reports_array}
                    fieldspecs={this.datasheetFieldSpecs}
                    delete={false}
                    edit={false}
                    handleDelete={null}
                    handleEdit={null}
                    loading={this.state.querying}
                    deleteHeaderName={'Delete'}
                    pagesize={10}
                    height={500}
                />

            </Paper>
            </Grid>

            <Grid item>
                <Typography color='secondary' style={{Width:1280,maxWidth:1280, textAlign:'center'}}>{this.state.error_message}</Typography>
                {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
            </Grid>

        </Grid>
    )}
    
}